import script from "./CrudEvento.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudEvento.vue?vue&type=script&setup=true&lang=js"

import "./CrudEvento.vue?vue&type=style&index=0&id=3140187a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3140187a"]])

export default __exports__